import Box from '@sendsprint/ui-react/dist/components/Box';
import Container from '@src/components/container';
import React, { useMemo } from 'react';
import Aside from './components/aside';
import Header, { HeaderProps } from './components/header';
import cs from 'classnames';
import ComplianceReview from './components/complianceReview';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useBusinessCheckContext } from '@src/contexts/business-check-context';
import Loader from '@src/components/loader';
import IdExpired from './components/idExpired';
import UpdateBusinessAddress from './components/updateBusinessAddress';
import { useAccount } from '@src/contexts';
import { Path } from '@src/navigations/routes';

export type LoggedInClient = 'receiver' | 'sender' | 'remittance' | 'white-label';

interface Props extends HeaderProps {
  client?: LoggedInClient;
  setFixedMainWidth?: boolean;
}

const DashboardLayout = ({ headerContent, client = 'receiver', setFixedMainWidth }: Props) => {
  const { resolvedPath } = useBusinessCheckContext();
  const { isLoggedIn, isWhiteLabelBusiness, businessVariant } = useAccount();

  // console.log({ resolvedPath }, 'dashboard layout');
  const { pathname } = useLocation();

  const isClientPages = useMemo(() => {
    if (isWhiteLabelBusiness) return pathname.includes('/white-label/');
    if (businessVariant === 'receiver') return pathname.includes('/receiver/');
    if (businessVariant === 'sender') return pathname.includes('/sender/');
  }, [isWhiteLabelBusiness, pathname, businessVariant]);

  if (!isLoggedIn) {
    return <Navigate to={Path.Login} replace />;
  }

  if (resolvedPath && resolvedPath === 'loading') {
    if (resolvedPath === 'loading') return <Loader />;
  }

  if (!isClientPages && !!resolvedPath) {
    return <Navigate to={resolvedPath} replace />;
  }

  return (
    <>
      <Box style={{ backgroundColor: '#F6F8FA' }} className="ss-min-h-screen ss-pb-6">
        <Header headerContent={headerContent} client={client} />
        <Box className="">
          <Container className="ss-flex ss-gap-8">
            <Aside client={client} />
            <Box
              as="main"
              className={cs('ss-w-full lg:ss-flex-1', {
                'lg:ss-w-[600px]': setFixedMainWidth
              })}>
              <IdExpired />
              <ComplianceReview />
              <Box className="ss-py-12">
                <Box>
                  <Outlet />
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>
        <UpdateBusinessAddress />
      </Box>
    </>
  );
};

export default DashboardLayout;
